export const streamTypes = {
  MOUNT_POINT_HD: 'mount_point_hd',
  MOUNT_POINT: 'mount_point',
  AUDIO_HLS: 'audio_hls',
  AUDIO_ACC: 'audio_aac',
  MP3_STREAM: 'audio_mp3',
};
